import { populationsApi } from '@/lib/api'
import { normalizePersonaMapKey } from '@/features/studies/report/audienceProfiles'

export async function resolvePopulationPersonaImages(
  populationId: string,
  names: Array<string>,
): Promise<Map<string, string>> {
  const imageByKey = new Map<string, string>()
  const uniqueNames = Array.from(
    new Set(names.map((name) => name.trim()).filter(Boolean)),
  )

  if (!populationId || uniqueNames.length === 0) {
    return imageByKey
  }

  await Promise.all(
    uniqueNames.map(async (name) => {
      try {
        const result = await populationsApi.getPersonasForPicker(populationId, {
          search: name,
          limit: 1,  // exact-name search; only the top result is needed
        })
        const match = result.personas?.find(
          (persona: { personaName?: string; imageUrl?: string }) =>
            normalizePersonaMapKey(persona.personaName || '') ===
            normalizePersonaMapKey(name),
        )
        if (match?.imageUrl) {
          imageByKey.set(normalizePersonaMapKey(name), match.imageUrl)
        }
      } catch {
        // Skip individual lookup failures; deck can still render without this portrait.
      }
    }),
  )

  return imageByKey
}
